import { carePlanTemplateApi } from "./care-plan-template";

export const carePlanTemplateQueryKeys = {
  all: ["settings", "care-plan-templates"] as const,
  list: () => [...carePlanTemplateQueryKeys.all, "list"] as const,
  detail: (id: string) =>
    [...carePlanTemplateQueryKeys.all, "detail", id] as const,
};

export const carePlanTemplateQueryOptions = {
  list: () => ({
    queryKey: carePlanTemplateQueryKeys.list(),
    queryFn: () => carePlanTemplateApi.list(),
  }),
  detail: (id?: string) => ({
    queryKey: carePlanTemplateQueryKeys.detail(id ?? ""),
    queryFn: () => carePlanTemplateApi.get(id ?? ""),
    enabled: !!id,
  }),
};
